import React from 'react';
import IconButton from '@mui/material/IconButton';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { useTheme } from '../../ThemeContext';
import { resolveClientColor } from '../../Utills/colors';
import './style.css';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const clientColor = resolveClientColor();

  return (
    <IconButton
      onClick={toggleTheme}
      className="theme-toggle-btn"
      aria-label={theme === 'dark' ? 'Modo claro' : 'Modo escuro'}
      size="small"
    >
      {theme === 'dark' ? (
        <LightModeIcon sx={{ fontSize: 20, color: clientColor }} />
      ) : (
        <DarkModeIcon sx={{ fontSize: 20, color: clientColor }} />
      )}
    </IconButton>
  );
};

export default ThemeToggle;
